"use client";

import { useT } from "@/features/i18n/hooks/use-t";
import useURL from "@/hooks/useURL";
import RouteBreadcrumb from "./";
import type { RouteBreadcrumbProps } from "./";

export default function RouteBreadcrumbClient(props: RouteBreadcrumbProps) {
  const { t } = useT();
  return <RouteBreadcrumb t={t} url={useURL()} {...props} />;
}
